module.exports = __webpack_public_path__ + "media/urubu.e4fd26d9.mp3";